/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbApprenantAzureGridDto } from './FcbApprenantAzureGridDto';
import {
    FcbApprenantAzureGridDtoFromJSON,
    FcbApprenantAzureGridDtoFromJSONTyped,
    FcbApprenantAzureGridDtoToJSON,
} from './FcbApprenantAzureGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbApprenantAzureGridDtoPaginatedResults
 */
export interface FcbApprenantAzureGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbApprenantAzureGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbApprenantAzureGridDto>}
     * @memberof FcbApprenantAzureGridDtoPaginatedResults
     */
    results?: Array<FcbApprenantAzureGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbApprenantAzureGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbApprenantAzureGridDtoPaginatedResults interface.
 */
export function instanceOfFcbApprenantAzureGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbApprenantAzureGridDtoPaginatedResultsFromJSON(json: any): FcbApprenantAzureGridDtoPaginatedResults {
    return FcbApprenantAzureGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbApprenantAzureGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbApprenantAzureGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbApprenantAzureGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbApprenantAzureGridDtoPaginatedResultsToJSON(value?: FcbApprenantAzureGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbApprenantAzureGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

